export {
  createSiderMenuHeaderRender,
  siderMenuContentRender,
} from '../SiderCollapse';

